module.exports = __webpack_public_path__ + "static/media/16-above-input-info-1.a021a11e.png";